export default __webpack_public_path__ + "static/media/guna_homes.9fa0f176.webp";